module.exports = __webpack_public_path__ + "img/map_2.032bdda5.png";